import Axios from 'axios';
import { AlertsResponse, AlertActionPayload, CriticalAlertFeedbackPayload } from 'model/api';

type Severity = 'warning' | 'critical' | 'info';
const DEFAULT_PAGE_SIZE = 25;

export const getAlerts = async (
  locationId: string | undefined | string[],
  userId?: string | undefined,
  severities: Severity[] = [],
  status?: string,
  alarmIds?: undefined | number[],
  page: number = 1,
  size: number = DEFAULT_PAGE_SIZE,
  createdAt: string | undefined = undefined,
  logFilterTab? : boolean, 
): Promise<AlertsResponse> => {

  // set locationIdsArr undefined and get no alert back, when when Log filter tab is selected and no location/alarm filter is set. 
  let locationIdsArr: string[] | undefined; 
  if (!logFilterTab) {
    if (typeof locationId === 'string')
      locationIdsArr = [ locationId ];
    else 
      locationIdsArr = locationId;
  }

  const severityParams = (severities.length > 0) ? '&' + severities.map(s => `severity=${s}`).join('&') : '';
  const pageParam = page ? `&page=${page}` : '';
  const sizeParam = size ? `&size=${size}` : '';
  const statusParam = status ? `&status=${status}` : '';
  const locationIdParam = (locationIdsArr && locationIdsArr.length > 0) ? '&' + locationIdsArr.map(l => `locationId=${l}`).join('&') : '';
  const userIdParam = userId ? `&userId=${userId}` : '';
  const alarmIdsParam = (alarmIds || []).length ? '&' + (alarmIds || []).map(a => `alarmId=${a}`).join('&') : '';
  const createdAtParam = createdAt ? `&createdAt=${createdAt}` : '';
  const query = `?isInternalAlarm=false${locationIdParam}${userIdParam}${statusParam}${severityParams}${pageParam}${sizeParam}${alarmIdsParam}${createdAtParam}`;

  const response = await Axios.get(`/alerts${query}`);
  return response.data;
}

export const postAction = async (payload: AlertActionPayload): Promise<any> => {
  const response = await Axios.post('/alerts/action', payload);
  return response.data;
}

export const postAlertFeedback = async (payload: CriticalAlertFeedbackPayload): Promise<any> => {
  await Axios.post(`/alerts/${payload.alertId}/userFeedback`, payload.apiPayload)
} 
